/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
export var PrefixShiftType = /*@__PURE__*/ (function (PrefixShiftType) {
    PrefixShiftType[PrefixShiftType["Line"] = 0] = "Line";
    PrefixShiftType[PrefixShiftType["Box"] = 1] = "Box";
    PrefixShiftType[PrefixShiftType["Border"] = 2] = "Border";
    return PrefixShiftType;
})({});
/**
 * @hidden
 */
export var PrefixShiftType_$type = /*@__PURE__*/ markEnum('PrefixShiftType', 'Line,0|Box,1|Border,2');
//# sourceMappingURL=PrefixShiftType.js.map
